/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Empty_TitleInputs */

const en_projects_empty_title = /** @type {(inputs: Projects_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing published yet`)
};

const lv_projects_empty_title = /** @type {(inputs: Projects_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vēl nekas nav publicēts`)
};

/**
* | output |
* | --- |
* | "Nothing published yet" |
*
* @param {Projects_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_empty_title = /** @type {((inputs?: Projects_Empty_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Empty_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_empty_title(inputs)
	return en_projects_empty_title(inputs)
});